import React from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@material-ui/core';

interface Props {}

const ProgressCenter = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Progress: React.FunctionComponent<Props> = props => {
  return (
    <ProgressCenter>
      <CircularProgress />
    </ProgressCenter>
  );
};

export default Progress;
